module.exports = __webpack_public_path__ + "img/visual-dashboard.992b0f26.svg";